__turbopack_context__.v({
  "color": "ColorInput-module__8eLO4G__color",
  "colorInputGrid": "ColorInput-module__8eLO4G__colorInputGrid",
  "selectedColorBackground": "ColorInput-module__8eLO4G__selectedColorBackground",
  "transparencyWrapper": "ColorInput-module__8eLO4G__transparencyWrapper",
  "transparentBackgroundPattern": "ColorInput-module__8eLO4G__transparentBackgroundPattern",
});
